<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Ordenes Convenios</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Transacciones</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2">
    <button type="button" class="btn btn-primary" (click)="crearFactura()">
      Crear Factura
    </button>
  </div>
</div>

<div class="row row-sm mb-3">
  <div class="col-12">
    <div class="card">
      <div class="card-header convenio-card-header">
        <h6 class="card-title mb-0 text-white">Filtrar</h6>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-12 col-md-6">
            <label class="form-label">Desde</label>
            <input type="date" class="form-control" [(ngModel)]="fechaInicio">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Hasta</label>
            <input type="date" class="form-control" [(ngModel)]="fechaFin">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Sucursal</label>
            <select class="form-control" [(ngModel)]="sucursal">
              <option value="">Seleccione...</option>
              @for (item of sucursales; track item.COD_SURC) {
                <option [value]="item.COD_SURC">{{ item.DIR_SURC }}</option>
              }
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Doctor (Con convenio activos)</label>
            <select class="form-control" [(ngModel)]="doctor" (ngModelChange)="cambiarDoctor()">
              <option value="">Seleccione...</option>
              @for (item of doctores; track item.CodVendedor) {
                <option [value]="item.CodVendedor">{{ item.NombreVendedor }}</option>
              }
            </select>
          </div>
          <div class="col-12 col-md-3">
            <button class="btn btn-secondary w-100" (click)="aplicarFiltros()">
              <i class="fe fe-search me-1"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <button class="btn btn-success" type="button" (click)="exportarExcel()" [disabled]="spinnerBoolean || !ordenes.length">
            Excel
          </button>
          <span class="text-muted tx-13">Seleccionadas: {{ totalSeleccionadas }}</span>
        </div>
        <div class="table-responsive">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                 class="table table-bordered table-striped table-hover ordenes-convenio-table">
            <thead>
              <tr>
                <th>#</th>
                <th>N. Orden</th>
                <th>Paciente</th>
                <th>Cod. Doctor</th>
                <th>Nombre Doctor</th>
                <th>Sucursal</th>
                <th>Responsable</th>
                <th>Fec. registro</th>
                <th>Servicios</th>
                <th>Facturar</th>
              </tr>
            </thead>
            <tbody>
              @for (orden of ordenes; track orden.COD_ORD; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ orden.NUM_ORD }}</td>
                  <td>{{ orden.NOM_CLI }}</td>
                  <td>{{ orden.CODN_DOC }}</td>
                  <td>{{ orden.NOM_DOC }}</td>
                  <td>{{ orden.DIRSUCS_ORD }}</td>
                  <td>{{ orden.responsable }}</td>
                  <td>{{ formatFecha(orden.fecha) }}</td>
                  <td>
                    <div class="servicios-box">
                      @for (servicio of orden.servicios; track $index) {
                        <div class="servicio-row">
                          <span>{{ servicio.producto }}</span>
                          <strong>$ {{ servicio.valor | number: '1.2-2' }}</strong>
                        </div>
                      }
                      <div class="servicio-row servicio-total">
                        <span>Total</span>
                        <strong>$ {{ totalServicios(orden.servicios) | number: '1.2-2' }}</strong>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <input type="checkbox"
                           [checked]="estaSeleccionada(orden)"
                           (change)="cambiarSeleccion(orden, $event)">
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
